export default "__VITE_ASSET__5d854977__"